import { combo } from "./combo";
import { supplies } from "./supplies";
import { bars } from "./bars";
import { grabAndGo } from "./grab-and-go";
import { duplicateMountableProduct } from "./duplicate-mountable-product";
import { XLSX_PICKER_PT_BR } from "./xlsx-picker";
import { newAndEditProduct } from "./new-and-edit-product";
import { beerDispenser } from "./beer-dispenser";
import { personalizationSettings } from "./personalization-settings";
import { cmv } from "./cmv";
import { productArea } from "./product-area";
import { productDetail } from "./product-detail";
import { technicalSheet } from "./technical-sheet";
import { productList } from "./product-list";
import { productForm } from "./product-form";
import { IMPORT_PRODUCTS_XLSX_PT_BR } from "./import-products-xlsx";

export const products = {
	barMultiSelect: {
		stock: "Estoque",
		printerIp: "IP Impressora",
		addAll: "Adicionar todos",
		removeAll: "Remover todos",
	},
	productArea,
	productDetail,
	technicalSheet,
	duplicateMountableProduct,
	productForm,
	productsTab: {
		tabTitle: "Produtos",
		searchLabel: "Pesquisar",
		searchPlaceholder: "Buscar produtos...",
		productsByCategory: "Produtos por Categoria",
		sortByCategory: "Organizar por categoria",
		sortByMenuCategory: "Organizar por categoria do menu",
		checkAllItems: "Selecionar todos os produtos ({{counter}})",
		uncheckAllItems: "Desmarcar todos produtos ({{counter}})",
		addProductButton: "Adicionar Produto",
		exportToExcelButton: "Exportar para excel",
		importProductsButton: "Importar produtos em massa",
		syncWithDelivery: "Sincronizar com delivery",
		editProductsViaExcel: "Editar produtos via excel",
		buttonDownloadQrCodes: "Baixar QR codes",
		downloadQrCodeAppSell: "Baixar QR codes de venda para o Zig App",
		editProducts: "Editar Produtos",
		deleteProducts: "Remover produtos",
		deleteSelectedProducts: "Excluir Selecionados",
		filters: {
			status: {
				all: "Todos",
				active: "Ativo",
				inactive: "Inativo",
			},
		},
		table: {
			activeBars: "Bares Ativos",
			name: "Produto",
			fiscalData: "Dados Fiscais",
			mountableDescription: "Produto Montável",
			hasProductionRule: "Ficha Técnica",
			value: "Preço",
			active: "Ativado",
			actions: "Ações",
			edit: "Editar",
			duplicate: "Duplicar produto montável",
			delete: "Remover",
			yesOption: "Sim",
			noOption: "Não",
			onDeleteProductMessage: "Deseja deletar o produto {{productName}}?",
			variable: "Variável",
			fiscalCode: "SKU",
		},
		onDeleteMessage: {
			title_one: "Deseja remover {{counter}} produto?",
			title_other: "Deseja remover {{counter}} produtos?",
			content: "Atenção! Os produtos serão removidos permanentemente.",
			okText: "Sim",
			cancelText: "Não",
		},
		syncModal: {
			title: "Sincronizar produtos",
			syncButton: "Sincronizar",
			chooseYourMenusMultiSelect: "Escolha seus cardápios",
			chooseTheVariablesCheckbox: {
				title:
					"Escolha as váriaveis que seráo sincronizadas para produtos já cadastrados no delivery:",
				all: "Todos",
				price: "Preço",
				category: "Categoria",
				subcategory: "Subcategoria",
				order: "Ordem",
				picture: "Foto",
				name: "Nome",
				description: "Descrição",
				mountableItems: "Itens montáveis",
			},
			activeSyncOptionCheckbox: "Ativar os produtos sincronizados para venda delivery",
			alertMessage:
				"Os produtos que não estão no delivery serão criados com as mesmas informações",
			successFeedback: "Sucesso, todos produtos sincronizados!",
			warningFeedback: "Alguns produtos tiveram problemas de sincronia.",
			warningFeedbackTable: {
				type: "Tipo",
				description: "Descrição",
			},
		},
		importModal: {
			import: "Importar",
			downloadSheet: "Baixar planilha",
			buttonText: "Escolher planilha",
			title: "Importar dispositivos de planilha",
			sheetFileName: "Produtos",
			activateProduct: "Ativar produtos importados",
			alertMessage:
				"Atenção! O valor dos produtos é informado em centavos, ex: 123 equivale a R$ 1,23",
			table: {
				columns: {
					product: "Produto",
					error: "Erro",
					description: "Descrição",
				},
				errors: {
					invalidTaxData: "Dados fiscais",
					ncm: "NCM",
					cest: "CEST",
					duplicatedFiscalCode: "SKU duplicado",
					productNotFound: "Produto não encontrado",
					categoryWithSubcategory: "Categoria",
					supercategoryNotFound: "Tipo do produto",
					name: "Nome",
					category: "Categoria",
					hasAlcohol: "Contém álcool",
					isHiddenFromApp: "Ocultar produto",
					value: "Preço",
					kind: "Tipo do produto",
					beerAbv: "ABV - Teor alcoólico",
					other: "Desconhecido",
					invalidSystemProduct: "Produto de sistema",
				},
				errorsDescription: {
					name: "Nome do produto não informado",
					category: "Categoria do produto não informada",
					hasAlcohol: "O campo precisa ser verdadeiro ou falso",
					isHiddenFromApp: "O campo precisa ser verdadeiro ou falso",
					value: "O preço do produto é inválido",
					kind: "O tipo do produto é inválido",
					beerAbv: "ABV - Teor alcoólico deve ser um número",
					other: "Erro desconhecido",
				},
			},
		},
		xlsxPicker: XLSX_PICKER_PT_BR,
		getTitleDialogActive: "Ativar produto",
		getTitleDialogDisable: "Desativar produto",
		getDescriptionDialogActive:
			"Deseja ativar esse produto nos produtos montáveis que ele compõe?",
		getDescriptionDialogDisable:
			"Deseja desativar esse produto nos produtos montáveis que ele compõe?",
		findFiscalGroupError: "Grupo fiscal cadastrado não encontrado",
		findFiscalProfileError: "Perfil fiscal cadastrado não encontrado",
		productWithoutCategory: "Produtos sem categoria do menu",
		onDeleteSelectProductsError: "Ops! Um problema ocorreu, tente novamente",
		testEmission: {
			titleSuccess: "Testando dados fiscais - Sucesso",
			titleError: "Ops, encontramos alguns erros",
			titleTesting: "Testando dados fiscais",
			updating: "Atualizando produtos...",
			testing: "Testando {{currentTest}}/{{length}}",
			loadingText: "Aguarde, estamos testando os produtos selecionados",
			success: "Dados fiscais testados com sucesso",
			successDescription: "Não foi encontrado nenhum erro nos dados apresentados",
		},
		activeAllQuestion: "Ativar todos?",
		disableAllQuestion: "Desativar todos?",
		activeAll: "Ativar todos",
		disableAll: "Desativar todos",
		testFiscalData: "Testar dados fiscais",
		limitOver: "Limite acima de {{limit}} selecionados",
		deleteSelect: "Excluir Selecionados",
		manageProducts: "Gestão de produtos",
		managePlaceProducts: "Gerencie os produtos do local",
	},
	newAndEditProduct,
	editProducts: {
		title: "Editar Produto",
		categoryChange: "Mudar categoria:",
		categoryNone: "Nenhuma",
		typeChange: "Mudar tipo:",
		typeNone: "Nenhum",
		save: "Salvar",
		confirm: "Deseja modificar os seguintes produtos ?",
	},
	combo,
	supplies,
	bars,
	grabAndGo,
	beerDispenser,
	personalizationSettings,
	cmv,
	productFeatureForm: {
		validateMessage: "Esse campo é obrigatório.",
		typeHere: "Digite aqui...",
		selectHere: "Selecione aqui...",
		templatesOptionsPlaceholder: "Selecione o modelo",
		org: "ORG",
		zig: "ZIG",
		observation: "Observação",
		fields: "Campos",
	},
	productList,
	importProductsXlsx: IMPORT_PRODUCTS_XLSX_PT_BR,
};
